;(function ($, _, window) {
    /** 
    * ECHTINTERACTIE, http://wijzijnecht.nl        
    * Construct the slider
    *
    * Example:  data-slider='' data-slider-config='{"duration":"4000","prevnext":true}'
    * TO-DO slider items dmv obj ipv dom creatie
    */ 
    var slider = function ($target, options, config) {
        /**
         * Check for jquery
         */
        if ($ === undefined) {
            throw '[data-slider] jquery is required';
        }

        /**
         * Check for lodash
         */
        if (_ === undefined) {
            throw '[data-slider] lodash is required';
        }
        
        /**
        * Set local variables
        */
        var config = {
    		prevnext: true,
    		pagination: true,
    		timer:true,
    		duration:6000
	    }; 
    
        this.$target = $target; //is obj
        this.options = $.extend(true, config, options);
        this.$slider_wrapper = $(this.options.wrapper);
        this.$tmpl_btn = $("script#tmpl-slider-btn").html() ? _.template($("script#tmpl-slider-btn").html()) : false;
        this.$tmpl_paging = $("script#tmpl-slider-paging").html() ? _.template($("script#tmpl-slider-paging").html()) : false;
        this.timer = '' //timer variable for auto loop function
        this.items = [];
        
        if(window.breakpoint() == 'breakpoint-mobile') {
            this.options.timer = false;
            this.options.pagination = false;
            this.options.prevnext = false;
        }
        
        //call _init function
        this._init();
    };


    /**
    *  init Slider function  
    **/    
    slider.prototype._init = function () {
        var self=this;
        
        self.items=this._getItems(); //get slider items
        
        if(self.options.prevnext && self.$tmpl_btn) 
            self._setPrevNext();
            
        if(self.options.pagination && self.$tmpl_paging)
            self._setPagination();
        
        if(window.breakpoint() == 'breakpoint-mobile') {
            //load all slider items.
            for(item in self.items) {
                self._loadItem(self.items[item]);
            }
        } else {            
            //load first item
            self._loadItem(self.items[0]);
        }
    };
    
    
    /**
    *  Load new Item  
    **/
    slider.prototype._loadItem = function(item) {
        var self=this,
            imgsrc=item.image,
            img = new Image();
		
		//clear timer
		if(self.options.timer)  
    		clearTimeout(self.timer);
        
        //set indicator
        self.$target.addClass('is--loading');
        
		//load new Item when image is loaded	
		$(img)
			.on("load", function () {
				//console.log(self.items.length-1);
				var imgObj=$(this),
					imgBox = $(item.obj).find(self.options.imageobj),
                    oldItem = _.find(self.items, { 'active': true });   
 
				imgBox.html(imgObj);
	                
	            //when active slide is--active remove active state
                if(oldItem) {
                    oldItem.active=false;
                    $(oldItem.obj).removeClass('is--active');
                }
                
                //remove loading class
                self.$target.removeClass('is--loading');
                
                //set new item active    
	            item.active=true;
                $(item.obj).addClass('is--active');

				self._updateNavigationControls(oldItem, item);
				
				//set timer function 
				if(self.options.timer)  
    				self._setTimer();
			})
			.attr('src', imgsrc);
    };
    
    
    /**
    * Set Prev and Next buttons function;
    **/
    slider.prototype._setPrevNext = function() {
        var self=this,
            objBtnNext = $(this.$tmpl_btn({"type":"next", "title":"Volgende", "icon":"icon-arrow-right"})),
            objBtnPrev = $(this.$tmpl_btn({"type":"prev", "title":"Vorige", "icon":"icon-arrow-left"}));
            
		if (self.items.length > 1) {
            
            objBtnPrev.bind('click', function(e){
                    self._nextItem('prev');
    			    e.preventDefault(); 
                })
                .appendTo(self.options.navwrapper);
            
            objBtnNext
			    .bind('click', function(e){
    			   self._nextItem('next');
    			   e.preventDefault(); 
			    })
			    .appendTo(self.options.navwrapper);   
        }
    };
    
    
    /**
    * Go to next slide function
    * used by prev and next button and timer function
    **/
    slider.prototype._nextItem = function(pos) {
        var self=this,
            nextPos = pos=='next' ? 1 : -1,
            activeItem = _.find(self.items, { 'active': true }),
            currentIndex= this.items.indexOf(activeItem);
        
        //check if last item
        if(self.items.length == currentIndex+1 && nextPos==1) {
            self._loadItem(self.items[0]);
            //console.log('einde')
        } else if(currentIndex==0 && nextPos==-1) { //check if first item
            self._loadItem(self.items[self.items.length-1]);
            //console.log('begin')
        } else {
            self._loadItem(self.items[currentIndex + nextPos]);
            //console.log('volgende')
        }
    };
    
    
    /**
    * Set pagination function
    **/
    slider.prototype._setPagination = function() {
        var self = this,
            objPaging = $(this.$tmpl_paging({"data": self.items}));

        //console.log(self.items, objPaging2);
        objPaging
            .appendTo(self.options.navwrapper);
        
/*
        if (self.items.length > 1) {
            .children('a')
                .bind('click', function(e){
					var obj=$(this),
					    objIndex= obj.data('id');
					   
                    
					//clearInterval(self.timer);
					self._loadItem(_.find(self.items, { 'id': objIndex }));
					 //clear interval
					e.preventDefault();
				});
				
            objPaging.appendTo(self.$target);	
		}
*/
    };
    
    
    /**
    * update update pagination and prev next buttons
    **/
    slider.prototype._updateNavigationControls = function(oldItem, item) {
        var self=this,
            currentIndex = this.items.indexOf(item);
        
        //update  pagination
        if(this.options.pagination) { 
            
            if(oldItem) {
                //this.$target
                    //.children('.slider-pagination')
                $(self.options.navwrapper)    
                    .find("[data-id='" + oldItem.id + "']")
                    .removeClass('is--active');
            }
            
            //this.$target
            $(self.options.navwrapper)
                .find("[data-id='" + item.id + "']")
                .addClass('is--active');
        }
    };
    
    
    /**
    * get slider items function
    **/
    slider.prototype._getItems = function() {
       
		var self=this,
			obj = self.$slider_wrapper.children(),
			items= [];
			
		obj.each(function(i){
			var obj = $(this),
				id = 'Item-'+i,
				img = obj.find(self.options.imageobj).attr('data-img'),
				title = obj.find(self.options.title).text();
			
			obj.attr('id',id); //set id to obj (easy to find)
			items.push({'id':id, 'image':img, 'title':title, 'obj':this, 'active': false});
		});
		
        return items;
    };
    
    /**
    * Timer function
    **/
    slider.prototype._setTimer = function() {
        var self=this;
       
            
        self.timer=setTimeout(function() {
			// Do something after 5 seconds

				self._nextItem('next');
	  	}, self.options.duration);
            
    };
    
    
    /**
     * On DOM ready
     */
    $(function () {
        /**
         * Initialize slider 
         */
        $('[data-slider]').each(function () {
            var $target = $(this),
                options = $target.data('slider');
            
            new slider($target, options);
        });

    });

})(jQuery, _, window);